// import EntypoIcon from '@expo/vector-icons/Entypo'

// import BackIcon from '../../components/BackIcon'
// import XTabNavIcon from '../../components/XTabNavIcon'

import BaseUISalePageAddItemWebView from 'xui/modules/storeWebsite/BaseUISalePageAddItemWebView'

export default class SalePageAddItemWebView extends BaseUISalePageAddItemWebView {}
